import { useNavigate } from "react-router-dom";
import { authorizationRoutes } from "../../Routes/paths";
import useRoleAuthentication from "./useRoleAuthentication";
import { useIdleTimer } from 'react-idle-timer'

const TIMEOUT = 60000 * (parseInt(process.env.REACT_APP_TIMEOUT) || 120);

function useLogOutOnIdle() {
  const navigate = useNavigate();
  const { isLoggedIn } = useRoleAuthentication();
  
  const handleOnIdle = (event) => {
    console.log("user is idle", event);
    console.log("last active", getLastActiveTime());
    isLoggedIn && navigate(authorizationRoutes.logout);
  };
  const { getLastActiveTime } = useIdleTimer({
    timeout: TIMEOUT,
    onIdle: handleOnIdle,
  });
}
export default useLogOutOnIdle;
